import { Link } from "react-router-dom";
import { navigationFooterLinks } from "views/landing/constants";
import { motion } from "framer-motion";
import clsx from "clsx";
import SoonItem from "../../SoonItem";

const footerContainerVariants = {
  hidden: { opacity: 1 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.6,
    },
  },
};

const cardVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: "easeOut" },
  },
};

const FooterNavigationLinks = () => {
  return (
    <motion.div
      className="w-full grid grid-cols-3 gap-[0.857vw] max-lg:grid-cols-1 max-lg:gap-[3.2vw] h-full"
      variants={footerContainerVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
    >
      {navigationFooterLinks.map(({ id, title, items }) => (
        <motion.article
          key={id}
          className="p-[0.857vw] bg-[#E9EBF3] navigation-card flex flex-col gap-[0.857vw] w-full max-lg:gap-[3.2vw] max-lg:p-[3.2vw]"
          variants={cardVariants}
        >
          <h3 className="navigation-card-title text-20 max-lg:text-[5.33vw] leading-[1.1] shadow-custom font-luxora-medium text-black w-full py-[0.571vw] pl-[0.857vw] max-lg:pl-[3.2vw] max-lg:py-[2.13vw]">{`${title}:`}</h3>

          <ul className="flex flex-col gap-[0.27vw] max-lg:gap-[1.06vw] relative">
            {items.map(({ name, url }) => {
              if (url === "#") {
                return (
                  <div className="relative group">
                    <div
                      className={clsx(
                        "w-full h-[3.071vw]  relative max-lg:h-[11.46vw] font-luxora-regular  cursor-pointer outline-none !opacity-85 rounded-xl text-[#00000099] max-lg:text-[4.26vw] max-lg:pl-[4.26vw] text-16 leading-[1.1] bg-[#F3F3F8] flex items-center pl-[1.142vw]"
                      )}
                    >
                      <p className="opacity-60">{name}</p>
                    </div>
                    <SoonItem />
                  </div>
                );
              }
              return (
                <Link
                  target="_blank"
                  rel="noopener noreferrer"
                  to={url}
                  key={name}
                  className={clsx(
                    "w-full h-[3.071vw] max-lg:h-[11.46vw] hover:bg-blue-200 transition-colors duration-300 rounded-xl text-[#00000099] max-lg:text-[4.26vw] max-lg:pl-[4.26vw] font-luxora-regular text-16 leading-[1.1] bg-[#F3F3F8] flex items-center pl-[1.142vw]",
                    url === "#" && "!pointer-events-none !opacity-85"
                  )}
                >
                  {name}
                </Link>
              );
            })}
          </ul>
        </motion.article>
      ))}
    </motion.div>
  );
};

export default FooterNavigationLinks;
